module.exports = __webpack_public_path__ + "images/marketing/peeps/paige_thomas.jpg";